if (!customElements.get('sample-product-form')) {
  customElements.define('sample-product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const mutipleProdData = [];
      const timestamp = Math.round(new Date().getTime()/1000);

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      /* ***Sample additional free products id's object*** */
      // const additionalAvailableIdsEle = document.querySelectorAll('[data-additional-prod-id]');
      // if(additionalAvailableIdsEle.length){
      //   additionalAvailableIdsEle.forEach(el => {
      //     if(el.value != ''){
      //       mutipleProdData.push({id: parseInt(el.value), quantity:1, properties:{"_musterSetKey": timestamp, "_musterSet": "true", "_additional-free-product": "Included", "_motive_title": el.dataset.additionalProdTitle }});  
      //     }
      //   });
      // }

      /* ***Sample products id's object*** */
      const availableIdsEle = document.querySelectorAll('.sample--klassik-grid [data-selected-variant-id]');
      const currentProdTitle = document.querySelector('[data-product-title]')?.getAttribute('data-product-title') || null;
      const currentProdImg = document.querySelector('[data-product-img]')?.getAttribute('data-product-img') || null;
      const sampleActionCfg = (typeof getSampleActionConfig === 'function') ? getSampleActionConfig() : null;
      if(availableIdsEle.length){
        availableIdsEle.forEach(el => {
          const currentProdPrice = el.dataset.discountedPrice || el.dataset.selectedVariantPrice;
          const sampleUnitPrice = (sampleActionCfg && sampleActionCfg.price) ? String(sampleActionCfg.price) : String(el.dataset.selectedVariantPrice || currentProdPrice);
          const sampleDiscountPct = (sampleActionCfg && sampleActionCfg.discountPercent) ? String(sampleActionCfg.discountPercent) : "50";
          if(el.dataset.selectedVariantId != ''){
            const itemProps = {"_sampleProducts": true, "_price": currentProdPrice, "_unit_price": sampleUnitPrice, "_discount_percent": sampleDiscountPct, "_motive_title": el.dataset.selectedVariantTitle, "_muster_set_title": currentProdTitle, "_muster_set_img": currentProdImg };
            // Danke-Seite (Küchenvorschau-Funnel): Messbarkeits-Property + sichtbares
            // Motiv. Auf der Muster-Seite ist data-cc-funnel nicht gesetzt -> unverändert.
            if (this.dataset.ccFunnel) {
              itemProps['_cc_funnel'] = this.dataset.ccFunnel;
              const motivName = (el.dataset.selectedVariantTitle || '').replace(/\s*\([^)]*\)\s*$/, '');
              if (motivName) itemProps['Motiv'] = motivName;
            }
            mutipleProdData.push({id: parseInt(el.dataset.selectedVariantId), quantity:1, properties: itemProps});
          }
        });
      }
      

      // **AddToCart All Sample Products** *//
      const CART_SECTION = this.cart.getSectionsToRender().map((section) => section.id);
      const ADDTOCART_OBJECT = { items: mutipleProdData, sections: CART_SECTION, sections_url: window.location.pathname };
      console.log('ADDTOCART_OBJECT -->', ADDTOCART_OBJECT);

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(ADDTOCART_OBJECT)
      })
      .then(response => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally((e) => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
